import { Conversations } from "@/components/conversations";
import { MentorWorkflowsShell } from "@/components/mentor-workflows";
import {
  readStoredMentorWorkspace,
  resolveMentorWorkspace,
} from "@/components/mentor-workflows/notice/workspace";
import { buildAbilityFromContext } from "@/lib/casl/route-guards";
import { useChatWorkspaceAccess } from "@/lib/hooks/conversations/use-chat-workspace-access";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";
import { PostHogEvents, useTrackPage } from "@/lib/posthog-events";
import { useNewMentorUI } from "@/lib/hooks/use-new-mentor-ui";

const searchSchema = z.object({
  segment: z.enum(["teens", "support"]).optional(),
  channel: z.string().optional(),
  internalChannelId: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/conversations/")({
  component: ConversationsPage,
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    const ability = buildAbilityFromContext(context.user);
    if (
      !ability.can("read", "messages") &&
      !ability.can("read", "internal-channels")
    ) {
      throw redirect({ to: "/" });
    }
  },
});

function ConversationsPage() {
  useTrackPage(PostHogEvents.PAGE_CHAT);

  const isNewMentorUIEnabled = useNewMentorUI();
  const { segment } = Route.useSearch();
  const [storedWorkspace] = useState(() => readStoredMentorWorkspace());
  const { canSeeTeens, canSeeSupport } = useChatWorkspaceAccess();
  const resolved = resolveMentorWorkspace(segment, storedWorkspace);
  const showSupport =
    resolved === "support" ? canSeeSupport : !canSeeTeens && canSeeSupport;

  if (isNewMentorUIEnabled && !showSupport) {
    return <MentorWorkflowsShell />;
  }

  return <Conversations />;
}
